<template>
  <div>
    <div v-if="check < 4">
      <b-row>
        <!-- Phase 1 -->
        <b-col lg="4">
          <div>
            <span style="font-size: 24px; font-weight: 500; color: #46E0E5; text-shadow: 0 0 4px #46E0E5;">
              Phase1
            </span>
          </div>
        </b-col>

        <!-- Phase 2 -->
        <b-col lg="4">
          <div>
            <span style="font-size: 24px; font-weight: 500; color: #46E0E5; text-shadow: 0 0 4px #46E0E5;">
              Phase2
            </span>
          </div>
        </b-col>

        <!-- Phase 3 -->
        <b-col lg="4">
          <div>
            <span style="margin-left: -12px; font-size: 24px; font-weight: 500; color: #46E0E5; text-shadow: 0 0 4px #46E0E5;">
              Phase3
            </span>
          </div>
        </b-col>
      </b-row>
    </div>

    <!-------------จราจร 4 Phase --------------->
    <div v-else>
      <b-row class="mr-5">
        <!-- Phase 1 -->
        <b-col lg="3">
          <div>
            <span style="margin-left: 17px; font-size: 24px; font-weight: 500; color: #46E0E5; text-shadow: 0 0 4px #46E0E5;">
              Phase1
            </span>
          </div>
        </b-col>

        <!-- Phase 2 -->
        <b-col lg="3">
          <div>
            <span style="margin-left: 10px;font-size: 24px; font-weight: 500; color: #46E0E5; text-shadow: 0 0 4px #46E0E5;">
              Phase2
            </span>
          </div>
        </b-col>

        <!-- Phase 3 -->
        <b-col lg="3">
          <div>
            <span style="font-size: 24px; font-weight: 500; color: #46E0E5; text-shadow: 0 0 4px #46E0E5;">
              Phase3
            </span>
          </div>
        </b-col>

        <!-- Phase 4 -->
        <b-col
          lg="3"
        >
          <div>
            <span style="font-size: 24px; font-weight: 500; color: #46E0E5; text-shadow: 0 0 4px #46E0E5;">
              Phase4
            </span>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import {
  BRow, BCol,
} from 'bootstrap-vue'
import axios from '@axios'
// import ModalPhase from '@/views/traffiscifi/detailfi/ModalGraphPhase.vue'

export default {
  // name: 'SVGAnimation',
  components: {
    BRow,
    BCol,

  },
  data() {
    return {
      // animate: false,
      iconColor: 'rgba(0, 228, 255, 0.5)',
      check: '',
    }
  },
  computed: {

  },
  beforeDestroy() {
    window.removeEventListener('resize', this.isSmallScreen)
  },
  mounted() {
    this.checkPhase()
    window.addEventListener('resize', this.isSmallScreen)
    this.interval = setInterval(() => {
      window.addEventListener('resize', this.isSmallScreen)
    }, 100000)
  },
  methods: {
    checkPhase() {
      axios
      // 732 722 223
        .post('/checkPhaseTraffic', { wid: this.$route.query.wid })
        .then(response => {
          this.check = response.data[0].PhaseNo
          this.countPhase = response.data[0].CountPhase
          console.log(this.countPhase)
        })
        .catch(error => {
          console.log(error)
        })
    },
    // toggleAnimation() {
    //   this.animate = !this.animate
    // },
    isSmallScreen() {
      return window.innerWidth <= 850
    },
  },
}
</script>

<style scoped lang="scss">

</style>
